import './ShareModal.css';
import { NebulaIcon as _, NebulaIconButton as w, NebulaButton as U, NebulaLabel as T, NebulaModal as M } from "@discoveryedu/nebula-components";
import { resolveComponent as m, openBlock as n, createElementBlock as c, createElementVNode as a, withModifiers as g, createVNode as h, Fragment as v, renderList as D, normalizeClass as L, toDisplayString as d, createBlock as p, Transition as B, withCtx as A, createCommentVNode as C } from "vue";
import { _ as y } from "./platform-components-assets/_plugin-vue_export-helper-es.js";
const W = {
  name: "ShareModalLinks",
  components: {
    NebulaIcon: _
  },
  data() {
    return {
      lmsOptions: [
        {
          label: "Schoology",
          learnMoreHref: "https://help.discoveryeducation.com/hc/en-us/articles/360057777473",
          embedLabel: this.$t("Schoology materials"),
          slug: "schoology"
        },
        {
          label: "Canvas",
          learnMoreHref: "https://help.discoveryeducation.com/hc/en-us/articles/360055921594",
          embedLabel: this.$t("Canvas assignments"),
          slug: "canvas"
        }
      ]
    };
  },
  props: {
    assetUrl: {
      type: String
    },
    assetTitle: {
      type: String
    },
    assetDescription: {
      type: String
    },
    customLink: {
      type: Boolean
    }
  },
  emits: ["clickedLMS"],
  computed: {
    googleShareUrl() {
      return `https://classroom.google.com/share?url=${this.assetUrl}&title=${this.shareTitle}`;
    },
    msShareUrl() {
      const e = `assignTitle=${this.shareTitle}`, t = `&href=${this.assetUrl}`, l = `&msgText=${this.msDescription}`, u = `&referrer=${window.location.origin}`;
      return `https://teams.microsoft.com/share?${e}${t}${l}${u}`;
    },
    msDescription() {
      return typeof this.assetDescription < "u" ? `Discovery Education - ${this.assetDescription}` : `Discovery Education - ${this.assetTitle}`;
    },
    shareTitle() {
      return `Discovery Education - ${this.assetTitle}`;
    },
    getLmsOptions() {
      return this.customLink ? [] : this.lmsOptions;
    }
  },
  methods: {
    openGoogleShareWindow() {
      window.open(
        this.googleShareUrl,
        "_blank",
        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=485,width=641"
      );
    },
    openMsShareWindow() {
      window.open(
        this.msShareUrl,
        "_blank",
        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=485,width=641"
      );
    }
  }
}, I = { class: "comet-list-group--list share-modal__lms-btn-list" }, E = { class: "comet-list-group__row share-modal__lms-btn" }, O = ["href", "data-title", "aria-label"], G = /* @__PURE__ */ a("span", { class: "share-modal__lms-link-label" }, "Google Classroom", -1), N = { class: "comet-list-group__row share-modal__lms-btn" }, x = ["data-href", "href", "data-assign-title", "data-msg-text", "aria-label"], V = /* @__PURE__ */ a("span", { class: "share-modal__lms-link-label" }, "Microsoft Teams", -1), F = ["onClick"], K = { class: "share-modal__lms-link-label" };
function Z(e, t, l, u, r, s) {
  const i = m("NebulaIcon");
  return n(), c("ul", I, [
    a("li", E, [
      a("a", {
        class: "comet-list-group__row-anchor share-modal__lms-link share-g-classroom-container",
        href: s.googleShareUrl,
        "data-title": s.shareTitle,
        "data-window-features": "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=485,width=641",
        "aria-label": e.$t("Share to Google Classroom - opens in a new window"),
        onClick: t[0] || (t[0] = g((...o) => s.openGoogleShareWindow && s.openGoogleShareWindow(...o), ["prevent"]))
      }, [
        G,
        h(i, {
          class: "share-modal__caret-right",
          symbolId: "caret-right"
        })
      ], 8, O)
    ]),
    a("li", N, [
      a("a", {
        class: "comet-list-group__row-anchor share-modal__lms-link microsoft-share-btn",
        "data-href": l.assetUrl,
        href: s.msShareUrl,
        "data-assign-title": l.assetTitle,
        "data-msg-text": s.msDescription,
        "aria-label": e.$t("Share to Microsoft Teams - opens in a new window"),
        onClick: t[1] || (t[1] = g((...o) => s.openMsShareWindow && s.openMsShareWindow(...o), ["prevent"]))
      }, [
        V,
        h(i, {
          class: "share-modal__caret-right",
          symbolId: "caret-right"
        })
      ], 8, x)
    ]),
    (n(!0), c(v, null, D(s.getLmsOptions, (o) => (n(), c("li", {
      key: o.slug,
      class: "comet-list-group__row share-modal__lms-btn"
    }, [
      a("button", {
        class: L(["comet-list-group__row-anchor share-modal__lms-link", `${o.slug}-share-btn`]),
        onClick: (S) => e.$emit("clickedLMS", o)
      }, [
        a("span", K, d(o.label), 1),
        h(i, {
          class: "share-modal__caret-right",
          symbolId: "caret-right"
        })
      ], 10, F)
    ]))), 128))
  ]);
}
const R = /* @__PURE__ */ y(W, [["render", Z]]), q = "data:image/png;base64,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", z = "data:image/png;base64,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", X = {
  name: "ShareModalLinksAssignmentLink",
  components: {
    NebulaIconButton: w
  },
  data() {
    return {
      lmsOptions: [
        {
          label: "Schoology",
          learnMoreHref: "https://help.discoveryeducation.com/hc/en-us/articles/360057777473",
          embedLabel: this.$t("Schoology materials"),
          slug: "schoology"
        },
        {
          label: "Canvas",
          learnMoreHref: "https://help.discoveryeducation.com/hc/en-us/articles/360055921594",
          embedLabel: this.$t("Canvas assignments"),
          slug: "canvas"
        }
      ]
    };
  },
  props: {
    assetUrl: {
      type: String
    },
    assetTitle: {
      type: String
    },
    assetDescription: {
      type: String
    }
  },
  emits: ["clickedLMS"],
  computed: {
    googleShareUrl() {
      return `https://classroom.google.com/share?url=${this.assetUrl}&title=${this.shareTitle}`;
    },
    msShareUrl() {
      const e = `assignTitle=${this.shareTitle}`, t = `&href=${this.assetUrl}`, l = `&msgText=${this.msDescription}`, u = `&referrer=${window.location.origin}`;
      return `https://teams.microsoft.com/share?${e}${t}${l}${u}`;
    },
    msDescription() {
      return typeof this.assetDescription < "u" ? `Discovery Education - ${this.assetDescription}` : `Discovery Education - ${this.assetTitle}`;
    },
    shareTitle() {
      return `Discovery Education - ${this.assetTitle}`;
    },
    mailToUrl() {
      const e = encodeURIComponent(this.assetTitle), t = encodeURIComponent("Please click on the link to view "), l = encodeURIComponent(`${this.assetTitle}: ${this.assetUrl}`);
      return `mailto:?subject=${e}&body=${t}${l}`;
    }
  },
  methods: {
    openGoogleShareWindow() {
      window.open(
        this.googleShareUrl,
        "_blank",
        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=485,width=641"
      );
    },
    openMsShareWindow() {
      window.open(
        this.msShareUrl,
        "_blank",
        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=485,width=641"
      );
    }
  }
}, Y = { class: "share-modal-links" }, j = { class: "share-modal-links__item" }, P = { class: "share-modal-links__item" }, Q = ["data-href", "href", "data-assign-title", "data-msg-text", "aria-label"], H = /* @__PURE__ */ a("img", {
  class: "share-modal-links__logo",
  src: q,
  alt: "Microsoft Teams Logo"
}, null, -1), J = [
  H
], $ = { class: "share-modal-links__item" }, ee = ["data-title", "href", "aria-label"], se = /* @__PURE__ */ a("img", {
  class: "share-modal-links__logo",
  src: z,
  alt: "Google Classrooms Logo"
}, null, -1), te = [
  se
];
function ae(e, t, l, u, r, s) {
  const i = m("NebulaIconButton");
  return n(), c("ul", Y, [
    a("li", j, [
      h(i, {
        icon: "mail",
        shape: "pill",
        size: "m",
        link: s.mailToUrl
      }, null, 8, ["link"])
    ]),
    a("li", P, [
      a("a", {
        class: "share-modal-links__link",
        "data-href": l.assetUrl,
        href: s.msShareUrl,
        "data-assign-title": l.assetTitle,
        "data-msg-text": s.msDescription,
        "aria-label": e.$t("Share to Microsoft Teams - opens in a new window"),
        onClick: t[0] || (t[0] = g((...o) => s.openMsShareWindow && s.openMsShareWindow(...o), ["prevent"]))
      }, J, 8, Q)
    ]),
    a("li", $, [
      a("a", {
        class: "share-modal-links__link",
        "data-title": s.shareTitle,
        href: s.googleShareUrl,
        "aria-label": e.$t("Share to Google Classroom - opens in a new window"),
        onClick: t[1] || (t[1] = g((...o) => s.openGoogleShareWindow && s.openGoogleShareWindow(...o), ["prevent"]))
      }, te, 8, ee)
    ])
  ]);
}
const le = /* @__PURE__ */ y(X, [["render", ae]]), oe = {
  name: "ShareModal",
  components: {
    NebulaButton: U,
    NebulaLabel: T,
    NebulaModal: M,
    ShareModalLinks: R,
    ShareModalLinksAssignmentLink: le
  },
  props: {
    asset: {
      assetId: {
        type: String
      },
      assetUrl: {
        type: String
      },
      assetType: {
        type: String
      },
      assetTitle: {
        type: String
      },
      assetDescription: {
        type: String
      },
      ssoUrl: {
        type: String
      }
    },
    productSettingCodes: {
      type: Array,
      default: () => []
    },
    config: {
      isStudent: {
        type: Boolean
      }
    },
    customLink: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close-modal"],
  data() {
    return {
      isActive: !0,
      alertActive: !1,
      selectedLMS: null
    };
  },
  computed: {
    shareUrl() {
      const e = this.asset.ssoUrl || window.location.origin;
      if (!this.asset.assetUrl)
        return this.handleUrlParams(`${e}/learn/player/${this.asset.assetId}`);
      const t = this.asset.assetUrl[0] === "/";
      return this.handleUrlParams(`${t ? e : ""}${this.asset.assetUrl}`);
    },
    isTeacher() {
      return !this.config.isStudent;
    },
    isStudent() {
      return this.config.isStudent;
    },
    lmsClassName() {
      return `share-modal__lms-heading--${this.selectedLMS.slug}`;
    },
    heading() {
      return this.selectedLMS ? `${this.selectedLMS.label} &amp; Discovery Education` : `${this.$t("Share")}`;
    },
    hasAssignmentLinkSettingAsProp() {
      return this.productSettingCodes.includes("DISTRIBUTABLE_LINKS_ENABLED");
    },
    assignmentLinksEnabled() {
      var e, t;
      return this.hasAssignmentLinkSettingAsProp || ((t = (e = window.initData) == null ? void 0 : e.product_settings) == null ? void 0 : t.DISTRIBUTABLE_LINKS_ENABLED);
    }
  },
  methods: {
    onClickedLMS(e) {
      this.selectedLMS = e;
    },
    clickClose() {
      this.closeModal();
    },
    closeModal() {
      this.$emit("close-modal");
    },
    onCopy() {
      this.alertActive = !0, setTimeout(() => {
        this.revertAlert();
      }, 1500);
    },
    onClickCopy() {
      this.$refs.urlCopy.select(), document.execCommand("copy");
    },
    focusInput() {
      this.$refs.urlCopy.focus();
    },
    revertAlert() {
      this.alertActive = !this.alertActive;
    },
    handleUrlParams(e) {
      try {
        const t = new URL(e);
        return t.searchParams.set("shared", "true"), t.toString();
      } catch {
        return e;
      }
    }
  },
  beforeUnmount() {
    const { assetId: e } = this.asset, t = document.getElementById(`action-menu--${e}`);
    t && t.focus();
  }
}, ne = ["innerHTML"], ie = {
  key: 0,
  class: "share-modal__lms-info"
}, re = { class: "share-modal__lms-instructions" }, ce = ["href"], de = { class: "nebula-button__text" }, he = {
  key: 1,
  class: "share-modal__share-links share-modal__share-links--assignment-link"
}, me = { class: "share-modal__copy-link-container" }, ue = { class: "nebula-field-group" }, pe = { class: "share-modal__description" }, ge = ["value", "aria-label"], be = {
  key: 0,
  class: "share-modal__lms-container"
}, Ae = { class: "share-modal__lms-share-heading" }, ye = { class: "share-modal__btn-group" }, Se = {
  key: 2,
  class: "share-modal__share-links"
}, Ce = { class: "share-modal__copy-link-container" }, Le = { class: "nebula-field-group" }, fe = ["value", "aria-label"], ke = {
  key: 0,
  class: "share-modal__lms-container"
}, _e = { class: "share-modal__lms-share-heading" }, we = { class: "share-modal__btn-group" };
function Ue(e, t, l, u, r, s) {
  const i = m("NebulaButton"), o = m("ShareModalLinksAssignmentLink"), S = m("NebulaLabel"), f = m("ShareModalLinks"), k = m("NebulaModal");
  return n(), p(B, null, {
    default: A(() => [
      h(k, {
        class: "share-modal",
        onCloseModal: s.clickClose,
        firstFocusedElement: "copy-button"
      }, {
        header: A(() => [
          a("h2", {
            class: "share-modal__heading",
            innerHTML: s.heading
          }, null, 8, ne)
        ]),
        content: A(() => [
          r.selectedLMS ? (n(), c("div", ie, [
            a("div", {
              class: L(["share-modal__lms-heading", s.lmsClassName])
            }, [
              a("span", null, d(r.selectedLMS.label), 1)
            ], 2),
            a("p", re, d(e.$t("Discovery Education digital resources can be embedded in %(embedLabel)s.", {
              embedLabel: r.selectedLMS.embedLabel
            })) + " " + d(e.$t("Add this resource to your Favorites and sign in to %(lmsName)s to share with students.", {
              lmsName: r.selectedLMS.label
            })), 1),
            a("a", {
              href: r.selectedLMS.learnMoreHref,
              target: "_blank",
              class: "share-modal__copy-btn nebula-button nebula-button--m nebula-button--square nebula-button--fill"
            }, [
              a("span", de, d(e.$t("Learn More")), 1)
            ], 8, ce)
          ])) : s.assignmentLinksEnabled ? (n(), c("div", he, [
            a("div", me, [
              a("div", ue, [
                a("p", pe, d(e.$t("Copy the resource link, and share it with others. The link will open directly to the resource page. This link does not generate a completable assignment.")), 1),
                a("input", {
                  type: "text",
                  class: "nebula-input nebula-input--l share-modal__input",
                  ref: "urlCopy",
                  value: s.shareUrl,
                  "aria-label": e.$t("Copy Link"),
                  onCopy: t[0] || (t[0] = (...b) => s.onCopy && s.onCopy(...b)),
                  readonly: ""
                }, null, 40, ge)
              ]),
              r.alertActive ? (n(), p(i, {
                key: 0,
                "icon-left": "check",
                type: "flat",
                text: e.$t("Copied!"),
                class: "share-modal__copy-btn share-modal__copy-btn--copied disabled",
                role: "alert"
              }, null, 8, ["text"])) : (n(), p(i, {
                key: 1,
                text: e.$t("Copy Link"),
                id: "copy-button",
                "icon-left": "copy",
                class: "share-modal__copy-btn",
                "data-click-name": "Copy Link",
                "data-click-type": "Share Modal",
                onClick: s.onClickCopy
              }, null, 8, ["text", "onClick"]))
            ]),
            s.isTeacher ? (n(), c("div", be, [
              a("h3", Ae, d(e.$t("Share via")), 1),
              a("div", ye, [
                h(o, {
                  assetUrl: s.shareUrl,
                  assetTitle: l.asset.assetTitle,
                  assetDescription: l.asset.assetDescription,
                  onClickedLMS: s.onClickedLMS
                }, null, 8, ["assetUrl", "assetTitle", "assetDescription", "onClickedLMS"])
              ])
            ])) : C("", !0)
          ])) : (n(), c("div", Se, [
            a("div", Ce, [
              a("div", Le, [
                h(S, {
                  class: "share-modal__label",
                  labelText: e.$t("Copy Link")
                }, null, 8, ["labelText"]),
                a("input", {
                  type: "text",
                  class: "nebula-input nebula-input--l share-modal__input",
                  ref: "urlCopy",
                  value: s.shareUrl,
                  "aria-label": e.$t("Copy Link"),
                  onCopy: t[1] || (t[1] = (...b) => s.onCopy && s.onCopy(...b)),
                  readonly: ""
                }, null, 40, fe)
              ]),
              r.alertActive ? (n(), p(i, {
                key: 0,
                "icon-left": "check",
                type: "flat",
                text: e.$t("Copied!"),
                class: "share-modal__copy-btn share-modal__copy-btn--copied disabled",
                role: "alert"
              }, null, 8, ["text"])) : (n(), p(i, {
                key: 1,
                text: e.$t("Copy Link"),
                id: "copy-button",
                class: "share-modal__copy-btn",
                "data-click-name": "Copy Link",
                "data-click-type": "Share Modal",
                onClick: s.onClickCopy
              }, null, 8, ["text", "onClick"]))
            ]),
            s.isTeacher ? (n(), c("div", ke, [
              a("h3", _e, d(e.$t("Share via Your Learning Management System")), 1),
              a("div", we, [
                h(f, {
                  assetUrl: s.shareUrl,
                  assetTitle: l.asset.assetTitle,
                  assetDescription: l.asset.assetDescription,
                  customLink: l.customLink,
                  onClickedLMS: s.onClickedLMS
                }, null, 8, ["assetUrl", "assetTitle", "assetDescription", "customLink", "onClickedLMS"])
              ])
            ])) : C("", !0)
          ]))
        ]),
        _: 1
      }, 8, ["onCloseModal"])
    ]),
    _: 1
  });
}
const De = /* @__PURE__ */ y(oe, [["render", Ue]]);
export {
  De as default
};
